import { Link, useLocation } from 'react-router-dom';
import Seo from '@/components/base/Seo';

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Seo
        title="页面不存在 | 黑料爆料"
        description="你访问的页面不存在或已被调整，返回首页即可查看最新的今日新瓜与实时更新情报流。"
        keywords="黑料爆料,页面不存在"
        path={location.pathname}
      />
      <div className="relative mx-auto flex w-full flex-col items-center justify-center px-4 py-28 text-center md:px-6">
        <span className="font-heading text-8xl text-background-300 select-none md:text-[10rem]">404</span>
        <h1 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">这个页面走丢了</h1>
        <p className="mt-3 max-w-md text-sm text-foreground-600">
          你访问的地址可能已被调整。返回首页，最新动态依然在实时更新中。
        </p>
        <p className="mt-2 text-xs text-foreground-500">{location.pathname}</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-label text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-arrow-left-line" />
            返回首页
          </Link>
          <Link
            to="/topics"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-label text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-400"
          >
            <i className="ri-layout-grid-line" />
            浏览专题分类
          </Link>
        </div>
      </div>
    </>
  );
}